import React from 'react';
import ProtectedRoute from '../../components/ProtectedRoute/ProtectedRoute';
import InterviewSittingPage from '../../features/interview/components/InterviewSittingPage';

const InterviewSittingPageRoute = () => (
  <ProtectedRoute requiresAuth={true}>
    <InterviewSittingPage />
  </ProtectedRoute>
);

export default InterviewSittingPageRoute;
